// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sk-1";
export var stateContainer = "_sk-0";